import {IFlag} from './flag.model';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {AbstractCrudService} from '../abstract-crud.service';
import {BehaviorSubject} from 'rxjs';
import {take} from 'rxjs/operators';
import {WebsocketService} from '../websocket/websocket.service';
import {WebsocketMessage} from '../websocket/websocketMessage';
import { AuthService } from '../../auth/auth.service';

@Injectable()
export class FlagService extends AbstractCrudService<IFlag> {

  private flags = new BehaviorSubject<IFlag[]>([]);
  public flags$ = this.flags.asObservable();
  //// tenant specific setting, default behaviour is to show per user
  private globalFlags:boolean = false;

  /**
   * URL for current model
   * @type {string}
   */
  protected url = environment.regoApiURL + 'flag';

  constructor(http: HttpClient, private websocket: WebsocketService,
      private authService: AuthService) {
    super(http);
    this.websocket.newWebsocketMessage$.subscribe((data) => {
      this.handleNewWebsocketMessage(data);
    });
    authService.login$.pipe(take(1)).subscribe(() => {
      this.globalFlags = this.authService.getTenantConfig().useGlobalFlags;
      this.initFlagList();
    });
  }

  private async initFlagList() {
    const t: IFlag[] = await this.getFlags();
    this.flags.next(t);
  }

  private flagCreatedByCurrentUser(flag: IFlag) {
    return this.globalFlags ? true : flag.userId === this.authService.getSubject();
  }

  private handleNewWebsocketMessage(msg: WebsocketMessage) {
    if (msg.target.includes('flag')) {
      const flag: IFlag = msg.body;
      if (!this.flagCreatedByCurrentUser(flag)) {
        return;
      }

      if (msg.type === 'delete') {
        this.initFlagList();
      } else {
        const list = this.flags.getValue();
        list.unshift(msg.body);
        this.flags.next(list);
      }
    }
  }

  private getFlags(): Promise<IFlag[]> {
    return this.http.get<IFlag[]>(this.url + '?withDeleted=false').toPromise().then(flags => {
      return flags.filter(flag => this.globalFlags?true:this.flagCreatedByCurrentUser(flag));
    });
  }
}
